import { useAppSelector } from "../../store/hooks";
import UnitReportScreen from "../reports/unitReportScreen";

export default function SharedUnitScreen() {
  const session = useAppSelector(state => state.session);
  return (<div>
    {session.shared?.project ? <UnitReportScreen project={session.shared.project} /> : <p>You must have a project shared.</p>}
  </div>);
}
